"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledArrowIcon = exports.StyledAbsolute = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactIdSwiper = _interopRequireDefault(require("react-id-swiper"));
var _reactLazyload = _interopRequireDefault(require("react-lazyload"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
require("swiper/css/swiper.css");
var _userflow = require("../../../utils/userflow");
var _CashBack = _interopRequireDefault(require("../../CashBack"));
var _Image = _interopRequireDefault(require("../../Image"));
var _Throbber = _interopRequireDefault(require("../../Throbber"));
var _HotelCardViewedLabel = _interopRequireDefault(require("./HotelCardViewedLabel"));
var _userAgentUtils = require("../../../utils/userAgentUtils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ArrowIcon = function ArrowIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 14.9L37 65l-21 50.1"
  }));
};
ArrowIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 53 130",
  fill: "none",
  stroke: "#fff",
  strokeWidth: "3",
  strokeLinecap: "round"
};
// TODO: выпилить после унификации урлов на беке
var DOMAIN = 's3.yc.level.travel/';
var settings = {
  shouldSwiperUpdate: true,
  slidesPerView: 1,
  swipe: true,
  loop: true,
  runCallbacksOnInit: false,
  preloadImages: false,
  lazy: {
    loadPrevNext: true,
    preloaderClass: 'swiper-lt-preloader'
  },
  watchSlidesVisibility: true
};
var OptionalLazy = function OptionalLazy(_ref) {
  var isLazy = _ref.isLazy,
    children = _ref.children;
  return isLazy ? /*#__PURE__*/_react["default"].createElement(_reactLazyload["default"], {
    once: true
  }, children) : children;
};
var HotelCardGallery = function HotelCardGallery(props) {
  var _props$isViewed = props.isViewed,
    isViewed = _props$isViewed === void 0 ? false : _props$isViewed,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
    className = props.className,
    bonusCount = props.bonusCount,
    isSmall = props.isSmall,
    _props$images = props.images,
    list = _props$images.list,
    count = _props$images.count,
    onSlideChange = _props$images.onSlideChange,
    autoplay = props.autoplay,
    link = props.link,
    _props$slidesPerView = props.slidesPerView,
    slidesPerView = _props$slidesPerView === void 0 ? settings.slidesPerView : _props$slidesPerView,
    currencyCode = props.currencyCode,
    _props$openInCurrentT = props.openInCurrentTab,
    openInCurrentTab = _props$openInCurrentT === void 0 ? false : _props$openInCurrentT,
    _props$isPreloadable = props.isPreloadable,
    isPreloadable = _props$isPreloadable === void 0 ? false : _props$isPreloadable;
  var extraSettings = isMobile ? {
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true
    }
  } : {
    navigation: {
      nextEl: '.swiper-button-custom-next',
      prevEl: '.swiper-button-custom-prev'
    }
  };
  var isSliderAvailable = count > 1 || isMobile;
  var _useState = (0, _react.useState)(isSliderAvailable),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showGallery = _useState2[0],
    setShowGallery = _useState2[1];
  var _list = (0, _slicedToArray2["default"])(list, 1),
    galleryCover = _list[0];
  (0, _react.useEffect)(function () {
    if (showGallery) {
      onSlideChange === null || onSlideChange === void 0 || onSlideChange();
    }
  }, [showGallery]);
  var mainImageJpgUrl = (0, _userflow.getFullUrl)(galleryCover.jpg, DOMAIN) || '';
  var mainImageWebpUrl = (0, _userflow.getFullUrl)(galleryCover.webp, DOMAIN);
  var mainImageUrl = mainImageWebpUrl || mainImageJpgUrl;
  var mainImageType = galleryCover.webp ? 'image/webp' : 'image/jpeg';
  var small = isSmall || isMobile;
  var propsDependedSettings = {
    renderPrevButton: function renderPrevButton() {
      return /*#__PURE__*/_react["default"].createElement(StyledArrowIcon, {
        $isMobile: isMobile,
        className: "swiper-button-custom-prev",
        type: "prev"
      });
    },
    renderNextButton: function renderNextButton() {
      return /*#__PURE__*/_react["default"].createElement(StyledArrowIcon, {
        $isMobile: isMobile,
        className: "swiper-button-custom-next",
        type: "next"
      });
    }
  };
  var openHotelInNewTab = function openHotelInNewTab() {
    if (link) {
      Object.assign(document.createElement('a'), {
        target: openInCurrentTab ? '_self' : '_blank',
        rel: 'noopener noreferrer',
        href: link
      }).click();
    }
  };
  return /*#__PURE__*/_react["default"].createElement(StyledContainer, {
    className: className,
    onMouseEnter: function onMouseEnter() {
      return setShowGallery(true);
    }
  }, _userAgentUtils.isSafari ? /*#__PURE__*/_react["default"].createElement(StyledImage, {
    src: mainImageJpgUrl,
    fetchpriority: isPreloadable ? 'high' : 'auto',
    onClick: openHotelInNewTab,
    alt: ""
  }) : /*#__PURE__*/_react["default"].createElement(OptionalLazy, {
    isLazy: !isPreloadable
  }, /*#__PURE__*/_react["default"].createElement(StyledPicture, {
    src: mainImageUrl,
    fetchpriority: isPreloadable ? 'high' : 'auto',
    fallback: mainImageJpgUrl || '',
    type: mainImageType,
    onClick: openHotelInNewTab,
    alt: "",
    "aria-hidden": "true"
  })), /*#__PURE__*/_react["default"].createElement("link", {
    itemProp: "image",
    href: mainImageUrl
  }), showGallery && count > 1 && /*#__PURE__*/_react["default"].createElement(_reactIdSwiper["default"], (0, _extends2["default"])({
    key: mainImageUrl
  }, _objectSpread(_objectSpread(_objectSpread({
    autoplay: autoplay
  }, settings), extraSettings), {}, {
    slidesPerView: slidesPerView
  }), propsDependedSettings), list.map(function (image, index) {
    var webpImageUrl = (0, _userflow.getFullUrl)(image.webp, DOMAIN);
    var jpgImageUrl = (0, _userflow.getFullUrl)(image.jpg, DOMAIN);
    var imageUrl = webpImageUrl || jpgImageUrl || '';
    var imageType = image.webp ? 'image/webp' : 'image/jpeg';
    var isImagePreloadable = isPreloadable && index === 0;
    return /*#__PURE__*/_react["default"].createElement(StyledGaleryItem, {
      key: imageUrl,
      itemProp: "photo",
      onClick: openHotelInNewTab
    }, _userAgentUtils.isSafari ? /*#__PURE__*/_react["default"].createElement(StyledImage, {
      "data-src": jpgImageUrl,
      className: "swiper-lazy"
    }) : /*#__PURE__*/_react["default"].createElement(StyledPicture, {
      className: "swiper-lazy",
      src: imageUrl,
      fetchpriority: isImagePreloadable ? 'high' : 'auto',
      loading: isImagePreloadable ? 'eager' : 'lazy',
      fallback: jpgImageUrl || '',
      type: imageType,
      alt: "",
      "aria-hidden": "true"
    }), index > 0 && /*#__PURE__*/_react["default"].createElement(_Throbber["default"], {
      className: "swiper-lt-preloader"
    }));
  })), /*#__PURE__*/_react["default"].createElement(StyledAbsolute, {
    small: small,
    isViewed: isViewed
  }, bonusCount && /*#__PURE__*/_react["default"].createElement(_CashBack["default"], {
    count: "+".concat(bonusCount),
    isMobile: isMobile
  }), isViewed && /*#__PURE__*/_react["default"].createElement(_HotelCardViewedLabel["default"], null)));
};
var StyledAbsolute = exports.StyledAbsolute = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardGallery__StyledAbsolute",
  componentId: "sc-1ynzrrf-0"
})(["display:flex;flex-direction:column;gap:3px;position:absolute;top:0;padding:8px 0 8px 8px;z-index:3;", ""], function (_ref2) {
  var small = _ref2.small,
    isViewed = _ref2.isViewed;
  return small && (0, _styledComponents.css)(["width:max-content;justify-content:space-between;", ""], isViewed && "\n        & > :last-child {\n          margin-right: auto;\n        }");
});
var StyledArrowIcon = exports.StyledArrowIcon = (0, _styledComponents["default"])(ArrowIcon).withConfig({
  displayName: "HotelCardGallery__StyledArrowIcon",
  componentId: "sc-1ynzrrf-1"
})(["", " position:absolute;right:0;cursor:pointer;height:70px;width:30px;z-index:10;top:calc(50% - 35px);left:", ";right:", ";transform:rotate(", ");transition:opacity 0.15s ease-in-out;&:hover{opacity:1 !important;}"], function (_ref3) {
  var $isMobile = _ref3.$isMobile;
  return !$isMobile && "opacity: 0;";
}, function (props) {
  return props.type === 'prev' ? 0 : 'auto';
}, function (props) {
  return props.type === 'next' ? 0 : 'auto';
}, function (props) {
  return props.type === 'prev' ? '180deg' : '0deg';
});
var StyledImage = _styledComponents["default"].img.withConfig({
  displayName: "HotelCardGallery__StyledImage",
  componentId: "sc-1ynzrrf-2"
})(["position:absolute;height:100%;width:100%;object-fit:cover;object-position:center;"]);
var StyledPicture = (0, _styledComponents["default"])(_Image["default"]).withConfig({
  displayName: "HotelCardGallery__StyledPicture",
  componentId: "sc-1ynzrrf-3"
})(["position:absolute;height:100%;width:100%;object-fit:cover;object-position:center;"]);
var StyledGaleryItem = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardGallery__StyledGaleryItem",
  componentId: "sc-1ynzrrf-4"
})(["width:100%;background-color:#f3f3f3;position:relative;display:inline-block;"]);
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardGallery__StyledContainer",
  componentId: "sc-1ynzrrf-5"
})(["position:relative;width:240px;height:100%;.swiper-container{height:100%;display:grid;.swiper-wrapper{min-width:0;}.swiper-pagination{width:110px !important;}.swiper-pagination-bullet{background:#c2c5cc;opacity:1;}.swiper-pagination-bullet-active{background:#fff;}}&:hover ", "{opacity:0.66;}.lazyload-wrapper{position:absolute;width:inherit;height:inherit;img{object-fit:cover;object-position:center;width:100%;height:100%;}}"], StyledArrowIcon);
var _default = exports["default"] = HotelCardGallery;